import { EDocumentKey, EI9DocumentPhotoSide } from "@zeal/common";
import { z } from "zod";

export const uploadI9OnboardingIDDocumentRequestSchema = z.object({
  companyID: z.string().optional(),
  workerID: z.string().optional(),
  document: z.any(),
  side: z.nativeEnum(EI9DocumentPhotoSide),
  documentType: z.nativeEnum(EDocumentKey),
});

export type TUploadI9OnboardingIDDocumentRequest = z.infer<
  typeof uploadI9OnboardingIDDocumentRequestSchema
>;

export type TExtractedIDDocumentDetails = {
  document_type?: EDocumentKey;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
  date_of_birth?: string;
  us_passport_number?: string;
  expiration_date?: string;
  expiration_date_type_a?: string;
  expiration_date_type_b?: string;
  expiration_date_type_c?: string;
  issuing_authority?: string;
  document_number?: string;
  document_bc_number?: string;
  alien_number?: string;
  foreign_passport_number?: string;
  country_code?: string;
  i551_number?: string;
  i766_number?: string;
  i94_number?: string;
  us_state_code?: string;
  sevis_number?: string;
  visa_number?: string;
  isMismatchedDocumentType?: boolean;
  isExpired?: boolean;
  isExpiringSoon?: boolean;
  error?: string;
  confidence_score?: number;
};
